export default {
  tab: 'CANDIDATES',
  title: {
    list: 'Applicant List',
    source: 'Source',
    applicationDetail: 'Application Detail',
    profileDetail: 'Profile',
    assessmentFit: 'Assessment Fit',
    problemSolvingFit: 'Problem Solving Fit',
    hiringManage: 'Select Hiring Manager(s)',
    addComments: 'Add Comment(s)',
    sendInvitation: 'Send Invitation(s)',
    selectInterviewQuestionnaire: 'Select an Interview Questionnaire',
    selectQuestionnaire: 'Select a Questionnaire',
    interviewerAndTimeAndLocation: 'Choose Hiring Manager(s) Interview time & Location',
    interviewTimeAndLocation: 'Interview Time & Location',
    copyCandidate: 'Copy Candidate to a Job',
    copyCandidates: 'Copy Candidates to a Job',
    tag: 'Tag',
    tip: 'Warning',
    exportCandidate: 'Export Candidate(s) ALL Info',
    potential: 'Applicant List - Potential',
    addTag: 'Add Tag',
    smartTags: 'Smart Tags',
    employer: 'Employer',
    jobTitle: 'Job Title',
    industry: 'Industry',
    skill: 'Skills',
    education: 'Education',
    crmTag: 'Tags',
    crmCampaign: 'CRM Campaign',
    candidateBehavior: 'Candidate Engagement',
    candidatePreferences: 'Preferences',
    otherFactors: 'Other Factors',
    candidateType: 'Candidate Type',
    aiTalentPoolRecommenderSelectJobTitle: 'Select Job to Generate Recommendation',
    aiTalentPoolRecommenderTitle: 'AI Talent Pool Recommender',
    smartTag: 'Smart Tags',
    aiRecommendedList: 'Talent Recommend List',
    recommendedInfo: 'AI Recommendations',
    selectHiringManager: 'Please select Hiring Manager: ',
    selectInterviewTimeRange: 'Please select three time slots, which will be shared with the candidates: ',
    selectLocation: 'Please select interview location: ',
    hiringManager: 'Interviewer: ',
    automate: 'Automated Scheduler: ',
    interviewType: 'Interview / Assessment Center Type',
    groupInterview: 'Quick Group Interview'
  },
  dialogTitle: {
    changeCandidateStatus: 'Change {candidateName} Status',
    changeMultipleCandidateStatus: 'Change Status',
    previewInterviewEmailDialogTitle: 'Interview Email Preview',
    previewInviteRateEmailDialogTitle: 'Rating Email Preview',
    aiComparisonLoadingTitle: 'Generate AI Comparison'
  },
  questionnairePreview: {
    questionLabel: 'Question {index}:',
    answerLabel: 'Answer:',
    interviewer: 'Interviewer',
    selectAll: 'All',
    weighting: 'Weighting {weight}%',
    questionType: {
      rating: 'Rating',
      text: 'Text',
      single: 'Single-select',
      multiple: 'Multi-select',
      date: 'Date'
    }
  },
  label: {
    name: 'Name',
    saveSearch: 'Save Search',
    keywords: 'Keywords',
    sourceChannel: 'Channel',
    referral: 'Referral',
    gender: 'Gender',
    job: 'Applied Job',
    candidateStatus: 'Candidate Status',
    status: 'Status',
    tag: 'Tag',
    candidateType: 'Candidate Type',
    contactStatus: 'Contact Status',
    workCompanyName: 'Employer',
    workCompanyNameSearch: 'Employer Keywords',
    lastWorkJobName: 'Job Title',
    lastWorkJobNameSearch: 'Job Title Keywords',
    location: 'Location',
    expectedLocation: 'Expected Working Location',
    graduateYear: 'Graduation Year',
    maxDegree: 'Highest Degree',
    workYear: 'Years of Experience',
    school: 'School',
    consentStatus: 'Consent Status',
    age: 'Age',
    ageAndGender: 'Age / Gender',
    candidateId: 'Candidate ID',
    employeeId: 'Employee ID',
    language: 'Languages',
    appliedDate: 'Applied Date',
    hiringManages: 'Input the contact information of the hiring manager(s) you would like to send invitations to:',
    hiringComments: 'Add some additional comments or insights about the candidate, for the reference of the hiring manager(s).',
    noOpenQuestion: 'There are currently no additional questions. Click Next to continue.',
    invitation: 'Review or customize the invitation, then send to the hiring manager(s):',
    confirmInterview: 'Create a Teams interview and send a final invitation email to hiring manager(s) and candidate(s).',
    invitationSubject: 'Subject',
    interviewQuestionnaire: 'Confirm the interview form to be rated by the interviewer(s).',
    ratingQuestionnaire: 'Confirm the form to be rated.',
    interviewType: {
      title: 'Interview Type',
      f2fType: 'On-site',
      online: 'Online',
      telephone: 'Telephone',
      teams: 'MS Teams',
      zoom: 'Zoom'
    },
    selectTemplate: 'Select Criteria from Template',
    createQuestion: 'Add',
    selectQuestionnaire: 'Select a questionnaire',
    selectInterviewQuestionnaire: 'Select an interview questionnaire',
    addQuestionnaire: 'Add questionnaire',
    select: 'Select',
    scale: 'Response Scale: ',
    noQuestionnaire: 'No questionnaire',
    interviewerAndTimeAndLocation: 'Please select the interviewer, time and location.',
    interviewTimeAndLocation: 'Please fill in the interview time and location:',
    selectAll: 'Select All',
    timeZone: 'Time Zone:',
    toStatus: 'Status',
    changeCandidateStatusCause: 'Reason',
    changeComment: 'Comment',
    saveNewSearch: 'Save new search',
    updateSearch: 'Update an existing saved search',
    weChatChannelName: 'WeChat',
    onboardDate: 'Estimated Onboard Date',
    hiredDate: 'Hired Date',
    employeeType: 'Employee Type',
    userEmail: 'User Email',
    endEmploymentDate: 'Employment End Date',
    compensationBasis: 'Compensation Basis',
    myJob: 'My Jobs',
    candidateName: 'Name',
    hidedCandidateName: 'Candidate',
    employee: 'Employee',
    candidate: 'Candidate',
    alumni: 'Alumni',
    alumniNew: 'New',
    employeeNew: 'New',
    candidateNew: 'New',
    employeeReferral: 'Employee SHARED Referrals',
    candidateReferral: 'Non-employee SHARED Referrals',
    employeeSubmitted: 'Employee SUBMITTED Referrals',
    candidateSubmitted: 'Non-employee SUBMITTED Referrals',
    degree: 'Education',
    selectedTag: '{count} Tag(s)',
    sendToHM: '1. For Hiring Manager',
    sendToCandidate: '2. For Candidate',
    applicant: 'applicant',
    applicants: 'applicants',
    people: 'applicants',
    pleaseStartTyping: 'Please start typing',
    total: 'Total',
    searchResult: 'Search Result',
    selected: 'Selected',
    resumeFit: 'Work Experience Fit',
    cultureFit: 'Culture Fit',
    personalityFit: 'Occupational Personality Fit',
    problemSolvingFit: 'Problem Solving Fit',
    aiInterviewFit: 'AI Interview Score',
    major: 'Major',
    group: 'Group',
    workExperienceYear: 'Work Experience',
    year: 'year(s)',
    month: 'month(s)',
    filter: {
      personalityFit: 'Occupational Personality Fit',
      cultureFit: 'Culture Fit'
    },
    recruiterQuestionnaire: 'Recruiter Screening',
    applicantQuestionnaire: 'Applicant Questionnaire Responses',
    prescreenQuestionnaire: 'Applicant Questionnaire Responses (Bot)',
    consentVersionCode: 'Version',
    joinedStartTimeJoinedEndTime: 'Join Date',
    activeness: 'Level of Activity',
    candidateSurveyQuestions: 'Candidate Preference Survey Responses ',
    employeeSurveyQuestions: 'Employee Preference Survey Responses ',
    company: 'Company',
    candidateNPS: 'Candidate NPS',
    problemSolvingFilter: {
      count_null: 'Problem Solving Assessment: No',
      count_1: 'Problem Solving Assessment: BASIC',
      count_2: 'Problem Solving Assessment: CAPABLE',
      count_3: 'Problem Solving Assessment: CAPABLE',
      count_4: 'Problem Solving Assessment: ADVANCED',
      count_5: 'Problem Solving Assessment: ADVANCED'
    },
    emailAddress: 'Email Address',
    referralChain: 'Referral Chain',
    baseInfo: 'Base info',
    jobs: 'Jobs',
    referralInfo: 'Referred By',
    noEmployee: 'Non-Employee',
    referralMobile: 'Mobile: ',
    referralEmail: 'Email: ',
    referralName: 'Name: ',
    referralReason: 'Referral Reason: ',
    new: 'Unread',
    all: 'Total',
    SCREEN: 'Screen',
    INTERVIEW: 'Interview',
    OFFER: 'Offer',
    HIRED: 'Hired',
    leads: 'Leads',
    openDays: 'Days old',
    readStatus: 'Read/Unread',
    applicationStatus: 'Resume Status',
    candidatePreferenceSurvey: 'Preference Survey',
    microsite: 'Microsite',
    previewCandidateEmail: 'To Candidate',
    previewHmEmail: 'To Hiring Manager',
    interviewer: 'Interviewer',
    scheduleType: {
      busy: 'Busy',
      noInfo: 'No Details Available',
      outsideOfWork: 'After-Hours Time',
      selected: 'Select'
    },
    cvOwner: 'CV Owner',
    ungrouped: 'Ungrouped',
    hasPhone: 'Mobile Available (Y/N)',
    aiAnalysisAction: 'AI Analysis',
    currentOnly: 'Current Only',
    skills: 'Skills',
    education: 'Education',
    workExperience: 'Work Experience',
    selectedTagCount: 'Selected {count} Tag(s)',
    stabilityTag: 'Work Stability (BETA)',
    riskTag: 'Potential Risks (BETA)',
    companyLevelTag: 'Leading Employers',
    workPositionTag: 'Unified Job Title',
    workIndustryTag: 'Unified Industry',
    workIndustry: 'Industry',
    lastWorkIndustry: 'Recent Industry',
    skillTag: 'Skills',
    hardSkillTag: 'Hard Skills (BETA)',
    softSkillTag: 'Soft Skills (BETA)',
    schoolTier: 'School Tier',
    foreignEducationExperience: 'Foreign Education Experience',
    crmTag: 'Tags',
    openedCampaign: 'Opened Campaign',
    sharedCampaign: 'Shared Campaign',
    appliedCampaign: 'Campaign Application',
    screenedCampaign: 'Campaign Application + Screened',
    interviewCampaign: 'Campaign Application + Interviewed',
    hiredCampaign: 'Campaign Application + Hired',
    expectedSalary: 'Expected Salary',
    appliedEntity: 'Applied Entity',
    BelongingEntity: 'Applied Entity',
    appliedJob: 'Applied Job',
    openedTag: 'Opened Job',
    sharedTag: 'Shared Job',
    appliedTag: 'Applied Job',
    industry: 'Industry',
    aiTalentPoolRecommenderJob: 'Job',
    aiTalentPoolRecommenderTip: 'Based on the job selected, AJINGA Intelligence recommends the following screening critera. Review and modify as needed, then click "Recommend" to generate your results. AJINGA Intelligence will recommend qualified candidates based on the degree of fit (A, B or C) to your job description.',
    aiTalentPoolRecommenderLocationLabel: 'Location',
    aiTalentPoolRecommenderLocationTip: 'If selecting multiple location, AJINGA Intelligence will consider candidates with at least one matched location.',
    aiTalentPoolRecommenderWorkExperienceLabel: 'Work Experience (years)',
    aiTalentPoolRecommenderDegreeLabel: 'Degree Level',
    aiTalentPoolRecommenderHardSkillLabel: 'Hard Skills',
    aiTalentPoolRecommenderHardSkillTip: 'If selecting multiple hard skills, AJINGA Intelligence will consider candidates with at least one matched hard skill.',
    aiTalentRecommendedListTitle: 'AI Talent Pool Recommendation',
    aiTaskCreatedTime: 'Date/Time',
    aiTaskCreatorName: 'Recruiter',
    aiRecommendIsGenerating: 'AI Talent Pool Recommendation is Generating',
    aiComparisonHistoryTitle: 'AI Candidate Comparison History',
    aiComparisonCandidates: 'Candidates',
    aiTaskAction: 'Action',
    aiTaskTime: '{weekday}, {month} {day}, {year}',
    aiComparisonRecommendedTitle: 'Recommended',
    aiComparisonSummaryTitle: 'Summary',
    confirmCreateJobCriterionTitle: 'Whether or not to go for job creation guidelines',
    confirmCreateJobCriterionContent: 'There are no guidelines available for the current job, does it go to the setup',
    recommendedStatus: 'Screened Candidate Recommendations List',
    historySearch: 'Recommendations History',
    historyIndex: 'Fit Model v{index} ({date})',
    aiRecommendedHistoryTitle: 'AI Recommendation History',
    noComparisonTip: 'Insufficient information',
    aiComparisonSummaryTip: 'The AJINGA Intelligence AI Comparison Table evaluates the selected candidates based on your key criteria and identifies the best match among them. This is a comparative analysis only—it does not assess all applicants or all job requirements. The recommendation simply highlights the strongest candidate from those selected, not necessarily the best fit for the role overall.',
    disabledStatus: '{status} (Disabled)',
    myCandidates: 'My Candidates',
    aiInterviewScore: 'AI Interview Score',
    interviewRecommendation: 'Interview Result',
    noticeRecruiter: 'Email to',
    showAll: 'Show All: ',
    interviewDuration: 'Duration:',
    hours: '{hour} hour(s)',
    minutes: '{minute} minute(s)',
    single: 'Single',
    multiple: 'Multiple',
    individual: 'Individual',
    groupInterviewType: 'Group',
    enableAutomate: 'Enable automated scheduling based on availability.',
    enableInterviewGroup: 'Add Group Interview Name',
    teamsMeeting: 'The system will generate a TEAMS link',
    zoomMeeting: 'The system will generate a Zoom link',
    selectTime: 'Select time',
    telephoneTip: 'The interviewers will contact the candidates on their own',
    metaIndustry: 'Industry',
    metaJobFunction: 'Job Function',
    talentRecommendation: {
      skills: 'Skills',
      createdTime: 'Date/Time',
      creatorName: 'Recruiter',
      serialNumberTitle: 'Version',
      serialNumber: 'Fit Model v{index} ({date}) - More Results {loadTask}',
      serialNumberBest: 'Fit Model v{index} ({date}) - Top Results',
      loadTaskSerialNumberBest: 'Top Results',
      loadTaskSerialNumber: 'More Results {loadTask}',
      loadTaskStatus: 'Status',
      recentIndustry: 'Recent Industry',
      jobFunction: 'Job Function',
      seniority: 'Seniority',
      status: {
        MOVED: 'Moved to Applicant List',
        INVITED: 'Invited to Apply',
        PENDING: 'Pending Screening',
        UNQUALIFIED: 'Unqualified'
      }
    },
    refreshAllCandidateAIResumeMatch: 'Refresh AI Fit Score',
    refreshAllCandidateAIResumeMatchContent: 'Currently there are unfinished tasks, is it confirmed to start again',
    confirmRefreshAllCandidateAIResumeMatchContent: 'This action is limited to once per week due to high resource usage. Are you sure you want to refresh the AI fit scores for all candidates?',
    aiSearch: 'AI Search',
    useAiSearch: 'Use AI Search'
  },
  placeholder: {
    selectJob: 'Select job',
    selectTag: 'Select Tag(s)',
    hiringEmails: 'Email',
    hiringFirstName: 'First Name',
    hiringLastName: 'Last Name',
    commentsPlaceholder: 'Please enter the content',
    userEmail: 'Create an email address for the candidate. Enter only the prefix.',
    compensationBasis: 'Please enter the Primary Compensation Basis (Salary/Hourly Rate in RMB).',
    groupKeyWord: 'Search by Group',
    searchQuestionnaire: 'Search',
    selectTimeZone: 'Select Time Zone',
    selectDate: 'Select Date',
    selectStartTime: 'Select Start Time',
    selectEndTime: 'Select End Time',
    selectLocation: 'Select Location',
    interviewCriteria: 'Input criteria that you want hiring manager to interview on.',
    keywordsSearch: 'Keyword search',
    candidateNameSearch: 'Candidate name search',
    candidateIdSearch: 'Candidate ID',
    employeeIdSearch: 'Employee ID',
    exportCandidateAllInfoTip: 'Search',
    onlineInterview: {
      url: 'Meeting URL (mandatory fill-in)',
      meetingId: 'Meeting ID (optional)',
      meetingPassword: 'Passcode (optional)'
    },
    microsite: 'Please select microsite',
    interviewEmailTemplateLanguage: 'Please select language',
    teamsMeetingGenerated: 'To be generated',
    input: 'Please input',
    selectMeetingRoom: 'Select Meeting Room',
    inputTelephone: 'Enter Telephone Number',
    aiSearch: 'Describe your ideal candidate—skills, experience, and location. Simply type as you would explain the role to a colleague.',
    select: 'Select',
    groupInterviewName: 'Group Name'
  },
  btn: {
    action: {
      changeStatus: 'Change Status',
      copyCandidate: 'Copy Candidate',
      copyCandidates: 'Copy Candidates',
      inviteHMRating: 'Invite hiring manager(s) rating',
      inviteInterview: 'Invite to interview',
      inviteAIInterview: 'Invite AI Interview',
      inviteAnswerQuestion: 'Send applicant questionnaire to candidate',
      inviteOnboarding: 'Invite onboarding questionnaire',
      inviteSatisfactionSurvey: 'Send satisfaction survey to candidate',
      invitePostApplicant: 'Send candidate experience portal to candidate',
      group: 'Group',
      talentGroup: 'Talent Group',
      talentExport: 'Export',
      exportAllCandidateInfo: 'Export All',
      addTalentGroup: 'Add Talent Group',
      editTalentGroup: 'Edit Talent Group',
      contact: 'Contact',
      inviteAnswerORQuestion: 'Invite OR questionnaire',
      addTag: 'Add Tag',
      inviteValueAndStrengthLabel: 'Invite to finish value & strengths',
      inviteProblemSolveLabel: 'Invite to finish problem solving',
      addComment: 'Add Comment',
      inviteAgreeConsent: 'Send Consent Email and SMS',
      createAIResumeMatch: 'Generate AI Fit Score',
      candidateAIMatchTable: 'View/Edit Candidate AI Fit Criteria',
      refreshAllCandidateAIResumeMatch: 'Refresh AI Fit Score',
      createAIComparison: 'Generate AI Comparison',
      viewAIComparisonHistory: 'View AI Comparison History',
      generateAIRecommendation: 'AI Talent Pool Recommendation',
      recommendMoreTalent: 'Generate More Recommendations',
      candidateAIComparisonTable: 'View/Edit Candidate AI Comparison Table',
      markRecommendedStatusToUnqualified: 'Mark as Unqualified',
      markRecommendedStatusToPending: 'Mark as Pending Screening',
      viewAIRecommendationHistory: 'AI Recommendation History',
      moveToApplyJob: 'Move Candidates to Applicant List'
    },
    uploadCandidate: {
      single: 'Add Individual Candidate',
      batch: 'Add Multiple Candidates (Batch Add) '
    },
    selectAll: 'Select all',
    interviewer: 'I am the interviewer',
    moveForward: 'Move Forward',
    reject: 'Reject',
    viewLeads: 'Click to view leads',
    viewCandidate: 'Click to view applicants',
    previewEmail: 'Preview',
    microsoftGraphTeamsMeeting: 'Create Microsoft Teams Meeting',
    clear: 'Clear',
    viewAITaskDetail: 'View',
    aiTalentPoolRecommenderBtn: 'Recommend',
    addTag: 'Add Tag',
    talentRecommendation: {
      view: 'View',
      retry: 'Retry',
      viewCondition: 'View Criteria',
      reset: 'Reset',
      regenerate: 'Regenerate',
      returnAndEdit: 'Back',
      inviteApplyJob: 'Invite to Apply Job',
      generateRecommendation: 'View/Edit Recommender Criteria'
    }
  },
  message: {
    endEmploymentDateBeforeHiredDate: 'Employment End Date cannot be earlier than Hired Date',
    compensationBasisPositive: 'Compensation Basis must be greater than 0',
    userEmailInvalid: 'The email prefix may contain only letters, numbers, dots, underscores, and hyphens. Spaces and @ are not allowed.',
    onlySameJobCandidatesCanInvite: 'Only candidates for the same job can be invited',
    saveOrUpdate: 'Save new search or update existing',
    addJobRequired: 'Please add at least one job',
    selectAtLeastCandidate: 'Please select at least one candidate',
    hmRequired: 'Please select at least one hiring manager',
    groupInterviewHmCount: 'Select at least two hiring managers to create a Quick Group Interview.',
    groupInterviewNameRequired: 'Enter a group name.',
    groupInterviewQuestionnaireRequired: 'Select a questionnaire to create a Quick Group Interview.',
    questionInterviewerRequired: 'Assign at least one hiring manager to each question.',
    allHmMustBeAssigned: 'Assign at least one question to every selected hiring manager.',
    inviteAIInterviewSuccess: 'Invite Successful',
    inviteAIInterviewResult: 'Of the {totalCount} people you selected to send this invitation, {successCount} have successfully been sent your invitation, {failedCount} invitation failed and {hasInvitedCount} have invited this AI interview.',
    inviteAgreeConsent: {
      success: 'Email and SMS sent successfully.',
      fail: 'Email and SMS sending failed.'
    },
    copyCandidate: {
      success: 'Copied Success',
      notAllSuccess: '{count} candidates already have applied for that position and will not be copied',
      failed: 'Copied Fail'
    },
    addTag: {
      success: 'Add Success',
      failed: 'Add Fail'
    },
    emailExisted: 'You can not input same email.',
    noData: 'No more data',
    deleteSearchTemplate: 'Please confirm you would like to delete this saved search.',
    deleteSuccess: 'Successfully Deleted',
    deleteGroupSuccess: 'Delete group successfully',
    npsHelpTip: {
      count: 'N = number of responses',
      inviteCount: '{invitationCount} is the number of invitations',
      rate: '{rate}% is the response conversion rate'
    },
    ExcelDownloadTip: [
      'Thank you, we are now processing your data for download. We will email you once finished.',
      'Please note, if you are attempting to download a LARGE amount of data (fields and records), it may take up to 2 hours to process. Thank you in advance for your patience.',
      'For LARGE downloads, you may also want to contact your client success consultant, to help monitor the download proactively for you and resolve any potential "dirty data" issues if they arise.'
    ].map((item) => `<p style="line-height: 20px">${item}</p>`).join(''),
    inviteORQuestion: 'Of the {inviteCount} people you selected to send this invitation, {successCount} have successfully been sent your invitation.',
    selectAllCandidateLimit: 'You can only select up to {maxLimit} candidates for this batch action. Please reselect the candidates. Contact your administrator or your AJINGA customer success consultant for more support. ',
    exportOriginalResumeTaskCreated: 'Export task has been created. We will notify you via email once completed.',
    inviteFinishAssessment: {
      success: 'Invite Success',
      noEmailAccount: 'This candidate do not have an email address, we cannot invite this candidate currently. Our SMS invitation is under developing. Coming SOON!',
      hasFinished: 'This candidate has completed the assessment and does not need to be invited',
      fail: 'Invite Failed',
      batchInvite: 'Of the {candidateCount} people you selected to send this invitation, {successCount} have successfully been sent your invitation, {noEmailCount} without email address and {completedCount} have either already previously completed this assessment'
    },
    scheduleSearchDayOutLimit: 'Data after 2 months is not available in Teams.',
    addToGenerateTaskSuccessful: 'Please give us a moment to process the fit score. Thank you!',
    aiComparisonCountError: 'Select from {min} to {max} candidates',
    aiComparisonCriterionError: "Let's get started!",
    aiComparisonCriterionErrorContent: 'Click the "Generate" button to establish your key comparison criteria.',
    aiComparisonError: 'Oops, something went wrong. Even AI needs a timeout sometimes! Please try again in a moment.',
    moveCandidateToApplication: {
      success: 'Updated',
      failed: 'Oops, something went wrong. Apologies! Please try again.'
    },
    confirmDeleteTagTip: 'Are you sure you want to delete this tag?',
    changeStatusResult: {
      consentFailed: 'Oops, it seems you cannot update this candidate status because this candidate has not yet consented to the privacy policy.',
      sameChangeRecord: 'The candidate is already set to this status. Please select a different status or close the window.',
      referralError: 'This job has a fixed-status-change-progression-logic due to the referral rewards program. Please update the next status in line with the referral progression logic. ',
      success: 'Status updated successfully.',
      batch: {
        success: 'Status updated successfully. ',
        failed: {
          base: [
            'Status updated successfully on {success} candidate(s).<br/>',
            '{failed} error(s):<br/>'
          ].join(''),
          join: ', <br/>',
          end: '.',
          consentFailed: '{consentFailed} candidate(s) have not yet consented to the privacy policy',
          sameChangeRecord: '{sameChangeRecord} candidate(s) were currently with this status',
          referralError: '{referralError} candidate(s) status failed because it does not follow the defined referral program status-change-progression-logic'
        }
      }
    },
    disabledActionCandidate: 'You do not have the authority to manage some of the candidates in this list. Please use the My Candidates toggle button in the left margin search bar to select My Candidates.',
    disabledActionCandidateInJob: 'You do not have the authority to manage the candidates in this job.',
    duplicateDateTime: 'Duplicate time slot selected. Please re-select.',
    changeDuration: 'Please change the duration',
    selectInterviewTime: 'Please select at least one time slot.',
    maxSelectScheduleCount: 'You can only select up to {maxCount} time slots.',
    aiRecommendSuccess: 'Successfully generated AI Talent Pool Recommendations.',
    aiRecommendNoCandidate: 'Oops, it seems there are no more candidate which fit this search criteria. Please expand your search criteria and try again.',
    recommendedIsEmptyRetryTip: 'There is no more candidate fit the recommender criteria. Please adjust the criteria and generate again.',
    sameRecommendationConditionTip: 'There are recommendation with the same conditions, you can choose to modify or view existed recommendation',
    copyRecommendedCandidateTitle: 'Confirm to move to the applicant list',
    copyRecommendedCandidateContent: 'Confirm to move {count} candidates to applicant list ?',
    copyOneCandidateRecommendedCandidateContent: 'Confirm to move to the applicant list ?',
    talentRecommendConditionGenerateFailed: 'Oops, AJINGA Intelligence is currently unavailable. Please try again.',
    updateRecommendedCandidateSuccess: 'Updated',
    recommendationLoadTaskRunningTip: 'You may wait for the results here, or close this pop up and review the results later by clicking the AI Talent Pool Recommendation, wtihin the job applicant list.',
    recommendationLoadTaskRunningStatus: {
      start: 'AJINGA Intelligence AI is processing your request.',
      review: 'AJINGA Intelligence AI is reviewing the criteria…',
      search: 'AJINGA Intelligence AI is searching the talent pool…',
      read: 'AJINGA Intelligence AI is reading the candidate resumes…',
      rankAndSummary: 'AJINGA Intelligence AI is comparing the candidates…',
      save: 'AJINGA Intelligence AI is curating the list of candidates for you…'
    },
    refreshAIResumeMatchError: 'Refresh is limited to once every week. Please come back in {day} day(s).',
    refreshAIResumeMatchSuccess: 'Thanks for your patience — we\'re calculating the fit scores.',
    noOriginalResume: 'No original resumes found in the selected data.'
  },
  referralType: {
    ALL_REFERRAL: 'All Referrals',
    EMPLOYEE_SHARED: 'Employee SHARED Referrals',
    CANDIDATE_SHARED: 'Non-employee SHARED Referrals',
    EMPLOYEE_SUBMITTED: 'Employee SUBMITTED Referrals',
    CANDIDATE_SUBMITTED: 'Non-employee SUBMITTED Referrals',
    NO_REFERRAL: 'Non-Referrals'
  },
  gender: {
    MALE: 'Male',
    FEMALE: 'Female',
    NON_BINARY: 'Non Binary',
    PREFER_NOT_TO_DISCLOSE: 'Prefer not to disclose'
  },
  candidateType: {
    EMPLOYEE: 'Employee',
    CANDIDATE: 'Non-Employee'
  },
  contactStatus: {
    HAS_CONTACTED: 'Contacted (Yes)',
    NO_CONTACTED: 'Contacted (No)'
  },
  consentStatus: {
    AGREED: 'Agreed',
    REJECTED: 'Rejected',
    PENDING: 'Pending'
  },
  tagMatchType: {
    ALL: 'All',
    ANY: 'Any'
  },
  activenessType: {
    HOT: 'Hot',
    ACTIVE: 'Active',
    WARM: 'Warm',
    COLD: 'Cold',
    POTENTIAL: 'Potential'
  },
  seniority: {
    INTERN: 'Intern',
    ENTRY_LEVEL: 'Entry Level',
    JUNIOR: 'Junior',
    MIDDLE_LEVEL: 'Mid-Level',
    SENIOR: 'Senior',
    LEADER: 'Supervisor',
    PRINCIPAL: 'Team Lead',
    MANAGER: 'Manager',
    DIRECTOR: 'Director',
    SENIOR_DIRECTOR: 'Senior Director',
    VP: 'Vice President (VP)',
    EVP: 'Executive Vice President (EVP)',
    CHIEF_OFFICER: 'Chief Officer (e.g., CTO, CFO)'
  },
  emailTemplate: {
    invitationSubject: 'New "{jobsName}" applicant(s) to review and rate',
    invitationContent: '{braceLeft} Company Default Email Header {braceRight}\n' +
      'Dear {braceLeft} User Name {braceRight},\n\n' +
      'You have received an invitation to review and provide a rating for candidate(s) who applied for "{jobsName}". Please click the link(s) and follow the instructions to submit your rating. I look forward to your response. \n\n' +
      '{braceLeft} Candidate Rate List {braceRight}\n' +
      '{braceLeft} Company Default Email Footer {braceRight}',
    hmInterviewSubject: 'Candidate Interview Invitation for "{jobsName}"',
    hmInterviewContent:
      'Dear {braceLeft} User Name {braceRight},\n\n' +
      'You have received an invitation for a candidate interview for the role of: {jobsName}. The interview details are outlined below: \n\n' +
      'Date:        {braceLeft} Date {braceRight}\n' +
      'Time:        {braceLeft} Start Time {braceRight} - {braceLeft} End Time {braceRight}\n' +
      '{addressContent}' +
      'Please find attached further information about the candidate(s) listed below together with the interview rating form. Please make sure to complete and submit the interview rating form directly after the interview. I look forward to your response.\n\n' +
      '{braceLeft} Candidate Info Table {braceRight}\n\n' +
      '{braceLeft} Recruiter Name {braceRight}\n',
    candidateInterviewSubject: 'Job Interview Invitation for "{jobsName}" at "{companyName}"',
    candidateInterviewContent:
      '{braceLeft} Company Default Email Header {braceRight}\n\n' +
      'Dear {braceLeft} User Name {braceRight},\n\n' +
      'You have received an invitation for a job interview for the role of: {jobsName} at {companyName}. The interview details are outlined below: \n\n' +
      'Date:        {braceLeft} Date {braceRight}\n' +
      'Time:        {braceLeft} Start Time {braceRight} - {braceLeft} End Time {braceRight}\n' +
      '{addressContent}{micrositeContent}' +
      '{braceLeft} Insert custom instructions to the candidate about what to do upon arrival or what to bring to the interview here {braceRight}\n\n' +
      '{qrCodeTips}{qrCodeHtml}{wechatCodeContent}' +
      '{braceLeft} Company Default Email Footer {braceRight}',
    wechatCodeContent: '<div style="text-align: center;font-weight: bold;font-size: 20px;"><p>Scan the QR code to receive interview from WeChat next time.</p><img height="150" class="qrcode" src="{{ bindingWechatQrcode }}"></div>\n\n',
    micrositeContent: '<a style="font-size: 20px;" href="{{ micrositeUrl }}">Click here to learn more</a>\n\n',
    addressContent: 'Address:     {{ English Location }}, {{ English Detail Address }}\n\n',
    onlineAddress: {
      url: 'Online Interview:       <a href="{{ Online URl }}">Click here to join the interview</a>\n',
      meetingId: 'Meeting ID:             {{ Meeting ID }}\n',
      password: 'Passcode:               {{ Meeting Password }}\n'
    }
  },
  PARENT_FIELD_NAME_LIST: {
    PersonalInfo: 'Personal Information',
    ApplicationInfo: 'Application Information',
    FitnessInfo: 'Fitness Scores',
    AssessmentInfo: 'Values, Strengths and Development Areas',
    InternExperienceInfo: 'Intern Experience',
    ExperienceInfo: 'Work History',
    EducationInfo: 'Education History',
    AdditionalInfo: 'Additional Information',
    LanguageInfo: 'Languages',
    jobSurveyInfo: 'Applicant Questionnaire',
    interviewRecordInfo: 'Interview Record',
    candidateConsentInfo: 'Candidate Consent Info',
    hmRateInfo: 'Hiring Manager(s) Rating',
    aiInterviewInfo: 'AI Interview Info'
  },
  STATUS_GROUP: {
    APPLY: 'Source',
    SCREEN: 'Screen',
    INTERVIEW: 'Interview',
    OFFER: 'Offer',
    HIRED: 'Hired'
  },
  READ_STATUS: {
    READ: 'Read',
    UNREAD: 'Unread'
  },
  candidatePreferenceSurvey: {
    COMPLETED_NO_APPLICATIONS: 'Completed survey + has NOT applied to a job',
    COMPLETED_HAS_APPLICATIONS: 'Completed survey + applied to a job'
  },
  APPLICATION_STATUS: {
    FINISHED: 'Complete',
    UNFINISHED: 'Incomplete'
  },
  agencyUploadStatus: {
    ACCEPTED: 'Accepted',
    REJECTED: 'Rejected',
    PENDING: 'Pending'
  },
  cvOwner: {
    hr: 'Recruiter',
    agency: 'Agency',
    disabledHr: 'Recruiter(Disabled)',
    disabledAgency: 'Agency(Disabled)'
  },
  resumeSDKTagKey: {
    INDUSTRY: 'Industry',
    POSITION: 'Position',
    JOB_SKILL: 'Job Skill',
    SOFT_SKILL: 'Soft Skill',
    COLLEGE_LEVEL: 'College Level',
    ABROAD_EDU: 'Abroad Edu',
    COMPANY_LEVEL: 'Company Level',
    JOB_STABILITY: 'Job Stability',
    RISKS: 'Risks'
  },
  recommendationLoadTaskStatus: {
    failed: 'Failed',
    success: 'Success',
    empty: 'No more candidates',
    pending: 'Generating'
  },
  AI_COMPARISON_TASK_STATUS: {
    START: 'AJINGA Intelligence AI is processing your request. You may wait for the results here or close this pop up at any time and review the results in the AI Comparison History table later.',
    REVIEW: 'AJINGA Intelligence AI is reviewing the criteria…',
    READING: 'AJINGA Intelligence AI is reading the candidate resumes…',
    COMPARING: 'AJINGA Intelligence AI is comparing the candidates…',
    THINKING: 'AJINGA Intelligence AI is thinking…',
    WRITING: 'AJINGA Intelligence AI is writing your comparison table…'
  },
  INTERVIEW_STATUS: {
    NOT_STARTED: 'Not Started',
    IN_PROGRESS: 'In Progress',
    COMPLETED: 'Completed'
  },
  tip: {
    companyLevelTag: 'This filter allows you to focus on candidates with experience at top-tier employers, such as Fortune 500 companies or other industry-leading organizations.',
    hardSkillTag: 'This filter allows you to focus on candidates based on their hard skills (specific, teachable abilities like coding, data analysis, or accounting), extracted by AJINGA Intelligence from their resume.',
    softSkillTag: 'This filter allows you to focus on candidates based on their soft skills (personal attributes like communication, teamwork, or problem-solving), extracted by AJINGA Intelligence from their resume.',
    schoolTier: 'This filter allows you to focus on candidates who attended top-tier universities in China, such as 211 or 985 institutions, based on the information extracted by AJINGA Intelligence from their resume.',
    stabilityTag: 'This filter allows you to focus on candidates with a potentially less stable work history, flagging those with an average tenure of less than 15 months at a single company.\nThe potential risks identified by this filter are only intended as a guide. This filter is based on the information provided in the candidate’s resume and may not fully reflect their complete background or suitability for the role. Therefore, please exercise caution when using this filter in decision-making.',
    riskTag: 'This filter allows you to focus on candidates with potential risks in their background, such as working gaps (periods of unemployment) or non-traditional educational backgrounds, including gaps in educational records, transitions from college to university level, or having only a vocational institution-level education.\nThe potential risks identified by this filter are only intended as a guide. This filter is based on the information provided in the candidate’s resume and may not fully reflect their complete background or suitability for the role. Therefore, please exercise caution when using this filter in decision-making.',
    selectHiringManager: 'Input the contact information of the interviewer(s) you would like to send invitations'
  },
  week: {
    mon: 'MON',
    tue: 'TUE',
    wed: 'WED',
    thu: 'THU',
    fri: 'FRI',
    sat: 'SAT',
    sun: 'SUN'
  }
}
